import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ManagerRoute({ component: Component, ...rest }) {
  const user = useSelector((state) => state.user);

  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('token') &&
        user.isFullRegister &&
        (user.typeProfile.type === 'manager' || user.typeProfile.type === 'admin' ) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export { ManagerRoute };
